import React, {useMemo} from 'react';
import {Infobox, Text} from '@flixbus/honeycomb-react';
import {LineErrorsProps} from './LineErrors.types';
import style from './LineErrors.module.scss';

const LineErrors: React.FC<LineErrorsProps> = ({errors}) => {
  const errorsList = useMemo(
    () =>
      errors.map((error, index) => {
        return (
          <Text key={index} extraClasses="no-margin">
            {error}
          </Text>
        );
      }),
    [errors]
  );

  return (
    <div className={style.container}>
      <Infobox aria-label="Some critical errors occurred" appearance="danger">
        <Text Elem="div" extraClasses="danger-color">
          <h3>Errors found</h3>
        </Text>
        {errorsList}
      </Infobox>
    </div>
  );
};

export default React.memo(LineErrors);
